const COMMON_FETCH_DISH_TYPES = {
  START: 'START_COMMON_FETCH_DISH_TYPES',
  COMPLETE: 'COMPLETE_COMMON_FETCH_DISH_TYPES',
  FAIL: 'FAIL_COMMON_FETCH_DISH_TYPES',
  CLEANUP: 'CLEANUP_COMMON_FETCH_DISH_TYPES',
}

export default COMMON_FETCH_DISH_TYPES
